import request from '../request'

/** API 通用响应包装 */
export interface ApiResponse<T = any> {
  success: boolean
  code: string
  message: string
  type: string
  content: T
}

/**
 * 学生互动任务 — 交互数据 & 回合要求展示
 * StuInteractionRecordWithRoundDTO
 */
export interface SeizeRecord {
  roundNum: number
  content: string
  resourceId: number
  /** 资源文件名称 — taskResource name */
  resourceFileName: string
  /** 开始时间 */
  startTime: string
  /** 结束时间 */
  endTime: string
  /** 轮次状态 */
  roundStatus: string
  courseName: string
  /** 记录表 id */
  studentRecordId: number
  classId: number
  taskId: number
  roundId: number
  studentId: number
  /** 学生所属组 ID */
  taskGroupId: number
  /** 点组模式下是否为组长 */
  leaderFlag: boolean
  /** 抢答排名 */
  rushRank: number
  /** 得分 */
  score: number
  /** 评语 */
  comment: string
  /** 是否计入成绩 */
  counted: boolean
  /** 是否已公布成绩 */
  published: boolean
  /** 是否从名单中移除 */
  removed: boolean
  /** 是否被禁用（每位同学仅能参与一次，被 ban 后再次进入展示禁用态） */
  isRemoved: boolean
  /** 是否成功抢答 */
  seizedSuccess: boolean
  /** 创建时间 */
  creationTime: string
}

/**
 * 互动任务扩展信息
 * TaskInteractionExtensionDTO
 */
export interface TaskInteractionExtension {
  extensionId: number
  taskId: number
  /** 抽选、抢答内容 */
  content: string
  /** 图片的资源 id */
  resourceId: number
  /** 图片的资源文件名 */
  fileResourceName: string
  /** 选人范围设置 */
  scopeConfig: string
  /** 预分组 id */
  groupPlanId: number
  /** 从池子里移除 */
  removeFromPool: boolean
  /** 本轮设定的抽取/抢答人数 */
  pickCount: number
  /** 学生班级身份 */
  stuIdentityTypes: ('TEACHING' | 'AUDITING')[]
}

/**
 * 学生任务明细
 * 来自 GET /task/student-task/detail/{classId}/{taskId}/{studentId}
 */
export interface StuTaskDetail {
  taskId: number
  /** 任务名称 */
  taskName: string
  classId: number
  /** 班级名称 */
  className: string
  courseId: number
  /** 课程名称 */
  courseName: string
  /** 课程周次 */
  courseWeek: number
  /** 任务发布时间 */
  taskPublishTime: string
  /** 任务截止时间 */
  taskDeadline: string
  /** 课程环节：BEFORE / DURING / AFTER */
  coursePhase: string
  /** PENDING 待发布 / RUNNING 进行中 / EXPIRED 已截止 */
  taskStatus: string
}

/** 学生抢答 */
export function fetchStudentSeize(taskId: number): Promise<ApiResponse<boolean>> {
  return request({
    url: '/task/interaction/student/seize',
    method: 'POST',
    data: { taskId }
  })
}

/** 查询抢答记录与回合 */
export function fetchSeizeRecord(taskId: number): Promise<ApiResponse<SeizeRecord[]>> {
  return request({
    url: `/task/interaction/student/interact-record/${taskId}`,
    method: 'GET'
  })
}

/** 互动任务扩展信息 */
export function fetchInteractionExtension(taskId: number): Promise<ApiResponse<TaskInteractionExtension>> {
  return request({
    url: `/task/interaction/extension-info/${taskId}`,
    method: 'GET'
  })
}

/** 明细查询学生任务 */
export function fetchTaskDetail(classId: string | number, taskId: number, studentId: number | string): Promise<ApiResponse<StuTaskDetail>> {
  return request({
    url: `/task/student-task/detail/${classId}/${taskId}/${studentId}`,
    method: 'GET'
  })
}

/** 学生抢答提醒任务项 — GET /task/student/rush-notify 的 activeTaskList 元素 */
export interface RushNotifyTask {
  courseId: number
  classId: number
  taskId: number
  taskName: string
  courseName: string
  courseWeek: number
  dayOfWeek: number
  taskPublishTime: string
  content: string
  resourceId: number | null
  roundId: number
  roundNum: number
  startTime: string
  endTime: string | null
  pickCount: number
  hasPermission: boolean
  [property: string]: any
}

/** 学生抢答提醒内容 */
export interface RushNotifyContent {
  activeTaskList: RushNotifyTask[]
  [property: string]: any
}

/** 拉取学生抢答提醒（进入系统主动请求，无入参） */
export function fetchStudentRushNotify(): Promise<ApiResponse<RushNotifyContent>> {
  return request({
    url: '/task/student/rush-notify',
    method: 'GET'
  })
}
